import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-flag",
  "use": "icon-si-glyph-flag-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-flag\" id=\"icon-si-glyph-flag\"><title>96</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1.000000, 0.000000)\" fill=\"#434343\"><rect x=\"0\" y=\"0\" width=\"1.99365234\" height=\"15.913\" class=\"si-glyph-fill\" /><path d=\"M3.056,0.52 L3.056,8.095 C3.056,8.095 4.667,6.664 8.244,8 C11.82,9.338 12.549,8.974 13.956,8.742 C13.956,8.742 11.908,7.871 10.734,4.713 C10.734,4.713 13.721,1.958 13.956,0.439 C13.956,0.439 10.256,1.651 8.205,0.68 C6.152,-0.293 3.994,-0.089 3.056,0.52 L3.056,0.52 Z\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-flag.svg
// module id = fdmO
// module chunks = 62